import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ReservationResponse, ReservationRequest } from '@builtbybros/al-model';
import { HttpService } from '../../../shared/http.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormsService } from '../../../shared/forms.service';
import moment = require('moment');
import { DatetimepickerComponent } from '../../../shared/datetimepicker/datetimepicker.component';
import { InitjsService } from '../../../shared/initjs.service';
import { AlertService } from '../../../shared/alert.service';

@Component({
  selector: 'app-reservation-form',
  templateUrl: './reservation-form.component.html',
  styleUrls: ['./reservation-form.component.scss']
})
export class ReservationFormComponent implements OnInit {
  reservationId: number;
  url = '/Reservation/';
  reservationForm: FormGroup;
  reservationData: ReservationResponse.Reservation;
  status: number;
  reservationLoaded = false;
  category: number;
  msg = {
    'update': 'Reserva actualizada correctamente'
  };

  @ViewChild(DatetimepickerComponent)
  private datetimepicker: DatetimepickerComponent;


  states = [
    [1, 'Pendiente'],
    [2, 'Aceptado'],
    [3, 'Rechazado'],
    [4, 'Cancelado'],
    [5, 'Entregado'],
    [6, 'Expirado']
  ];

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private formsService: FormsService,
    private httpService: HttpService,
    private initJsService: InitjsService,
    private alertService: AlertService
  ) {
    this.createFormGroup();
  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      if (params['reservationId']) {
        this.reservationId = +params['reservationId'];
        const responseExpected = new ReservationResponse.Reservation();
        this.httpService.get(this.url, this.reservationId, responseExpected)
          .subscribe(
            reservationResponse => {
              this.reservationLoaded = true;
              this.reservationForm.patchValue(reservationResponse);
              this.reservationForm.patchValue({'initialDate': moment(reservationResponse['initialDate']).format('DD/MM/YYYY')});
              this.reservationForm.patchValue({'expirationDate': moment(reservationResponse['expirationDate']).format('DD/MM/YYYY')});
              this.reservationForm.patchValue({'name': reservationResponse['user']['name']});
              this.reservationForm.patchValue({'email': reservationResponse['user']['email']});
              this.category = +reservationResponse['user']['userRoleId'];
              this.reservationForm.get('name').disable();
              this.reservationForm.get('email').disable();
              this.reservationForm.get('initialDate').disable();
              this.status = reservationResponse.status;
              this.reservationData = reservationResponse;
              const date = moment(reservationResponse.expirationDate).format('DD/MM/YYYY');
              this.datetimepicker.selectDate(date);
            },
            error => {
              this.alertService.error(error);
            }
          );
      }
    });
    this.initJsService.initJs();
  }

  setStatus(value) {
    this.status = +value;
  }

  submitForm() {
    if (this.formsService.validateFormAndUpdateErrors(this.reservationForm)) {
      const reservation = new ReservationRequest.Update();
      reservation.status = this.status;
      const responseExpected = new ReservationResponse.Reservation();
      this.httpService.patch(this.reservationId, '/Reservation/', reservation, responseExpected)
        .subscribe(
          reservationResponse => {
            this.alertService.success(this.msg['update']);
          },
          error => {
            this.alertService.error(error);
          }
        );
    }
  }

  setDate(dateString: string) {
    this.reservationForm.controls['expirationDate'].setValue(moment(dateString, 'DD-MM-YYYY').toDate());
  }

  private createFormGroup() {
    this.reservationForm = this.fb.group({
      'name': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'email': [
        null,
        Validators.compose([
          Validators.required,
          Validators.email
        ])
      ],
      'initialDate': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'expirationDate': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'status': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ]
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/reservation/shared/reservation-form/reservation-form.component.ts